import { Container, Row, Col, Card } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import BackButton from "../../Includes/BackButtonEntityAccount";
import { Avatar, Button, Alert } from "@mui/material";
import { Link } from "react-router-dom";
import reg_entity from "../../../images/create_entity_ques1_icon1.png";
import reg_entity2 from "../../../images/create_entity_ques1_icon2.png";
import reg_entity3 from "../../../images/create_entity_ques1_icon3.png";
import reg_entity4 from "../../../images/create_entity_ques1_icon4.png";
import { reduxForm, InjectedFormProps } from "redux-form";
import { connect } from "react-redux";
import {
  setwizardPageNumber,
  setEntityAccountUserDetails,
  setwizardPageName,
} from "../../EntityAccountReducer";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { ToastBox, notifyError } from "MyComponents/Toaster";
import Spacer from "MyComponents/UI/Spacer";
import { updateEntityKycDraftStep } from "Utils/entityKycDraft";
import ApartmentIcon from "@mui/icons-material/Apartment";
import LockIcon from "@mui/icons-material/Lock";
import { useTranslation } from "react-i18next";

interface Props {}

const CreateEntityFirstQues: React.FC<
  Props & InjectedFormProps<{}, Props, FormData>
> = (props: any) => {
  const { handleSubmit } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const page = useSelector(
    (state: RootState) => state.entityAccount.wizardPageNumber
  );
  const entityAccountUserDetails = useSelector(
    (state: RootState) => state.entityAccount.entityAccountUserDetails
  );
  const userID = useSelector((state: RootState) => state.entityAccount.userID);
  const theme = useSelector((state: RootState) => state.theme.theme);
  const [registerBusinessValidation, setRegisterBusinessValidation] =
    useState(false);

  useEffect(() => {
    dispatch(setwizardPageName("eligibilityA"));
  }, [dispatch]);

  const onClickYes = async () => {
    const updatedObject = {
      ...entityAccountUserDetails,
      RegisteredBusiness: "1",
    };
    try {
      if (userID) {
        await updateEntityKycDraftStep(userID, 'EntityAccountUser', { registeredBusiness: "1" });
      }
      dispatch(setEntityAccountUserDetails(updatedObject));
      dispatch(setwizardPageNumber(page + 1));
      localStorage.setItem('pageNumber', `${page + 1}`);
      setRegisterBusinessValidation(false);
    } catch (error) {
      console.error("Draft update error:", error);
      notifyError("Failed to save progress.");
    }
  };

  const onClickNo = async () => {
    const updatedObject = {
      ...entityAccountUserDetails,
      RegisteredBusiness: "0",
    };
    try {
      if (userID) {
        await updateEntityKycDraftStep(userID, 'EntityAccountUser', { registeredBusiness: "0" });
      }
      dispatch(setEntityAccountUserDetails(updatedObject));
      setRegisterBusinessValidation(true);
    } catch (error) {
      console.error("Draft update error:", error);
      notifyError("Failed to save progress.");
    }
  };

  return (
    <>
      <Container
        fluid
        className={`${theme === "dark" ? "bg-black" : " bg-sky"} min-vh-custom`}
      >
        <Row className="px-3 px-md-5">
          <Col md={12}>
            <div className="mt-5">
              <Row>
                <Col md={12}>
                  <Row>
                    <Col md={6} sm={12} className="">
                      <img src={reg_entity} width={50} className="" />
                      <Row className="mb-3">
                        <Col md={10} className="mt-4">
                          <h3>
                            {t('kyc.entity_ques1_heading')}
                          </h3>
                          <p className="text-secondary small">
                            {t('kyc.entity_ques1_desc')}
                          </p>
                          <p className="fw-bold  mt-4">
                            {t('kyc.registered_business_q')}
                          </p>
                          <Row className="ps-2 g-3">
                            <Col xs={12} md={5} className="rounded-4" role="button">
                              <Button
                                fullWidth
                                onClick={onClickYes}
                                variant="contained"
                                disableElevation
                                sx={{
                                  backgroundColor:entityAccountUserDetails?.RegisteredBusiness==="1" ? "#e6f0ff": "#ffffff",
                                  borderRadius: "16px",
                                  padding: "16px !important",
                                  boxShadow: entityAccountUserDetails?.RegisteredBusiness==="1"? "0 0 0 2px #00D084 inset" : "0px 1px 3px rgba(0, 0, 0, 0.2)",
                                  textTransform: "none",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  color: "#000",
                                  "&:hover": {
                                    backgroundColor: "#f9f9f9",
                                  },
                                }}
                              >
                                <Avatar
                                  sx={{
                                    backgroundColor: "rgba(0, 123, 255, 0.1)",
                                    color: "#00D084",
                                    width: 32,
                                    height: 32,
                                  }}
                                >
                                  <ApartmentIcon fontSize="small" />
                                </Avatar>
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    display: "inline-block",
                                  }}
                                >
                                  {t('kyc.yes_i_do')}
                                </span>
                              </Button>
                            </Col>
 
                            <Col
                              xs={12}
                              md={5}
                              className="rounded-4"
                              role="button"
                            >
                              <Button
                                fullWidth
                                onClick={onClickNo}
                                variant="contained"
                                disableElevation
                                sx={{
                                  backgroundColor:entityAccountUserDetails?.RegisteredBusiness==="0"? "#e6f0ff": "#ffffff",
                                  borderRadius: "16px",
                                  padding: "16px !important",
                                  boxShadow: entityAccountUserDetails?.RegisteredBusiness==="0"? "0 0 0 2px #00D084 inset" : "0px 1px 3px rgba(0, 0, 0, 0.2)",
                                  textTransform: "none",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                  color: "#000",
                                  "&:hover": {
                                    backgroundColor: "#f9f9f9",
                                  },
                                }}
                              >
                                <Avatar
                                  sx={{
                                    backgroundColor: "rgba(0, 123, 255, 0.1)",
                                    color: "#00D084",
                                    width: 32,
                                    height: 32,
                                  }}
                                >
                                  <LockIcon fontSize="small" />
                                </Avatar>
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    display: "inline-block",
                                  }}
                                >
                                  {t('kyc.no_i_dont')}
                                </span>
                              </Button>
                            </Col>
                          </Row>

                          <div
                            id="registerBusiness_validation"
                            className={
                              registerBusinessValidation
                                ? "mt-3"
                                : "d-none"
                            }
                          >
                            <Alert severity="error" variant="outlined" sx={{ borderRadius: '12px', fontWeight: 500 }}>
                              {t('kyc.business_reg_required')}
                            </Alert>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={1}></Col>
                    <Col md={5} className="px-4 d-none d-md-block">
                      <Card
                        className={`p-3  border-0 rounded-4 my-4  ${
                          theme === "dark" && "bg-black"
                        }`}
                      >
                        <p className="text-secondary fw-bold">
                          {t('kyc.entity_features_title')}
                        </p>

                        <p className="text-secondary small">
                          {t('kyc.entity_available_desc')}
                        </p>

                        <Col
                          md={12}
                          className={`rounded-4 ${
                            theme === "light" && "bg-body-tertiary"
                          } mt-2`}
                        >
                          <Row className="  p-2">
                            <Col md={8} className=" d-flex align-items-center">
                              <img
                                className="row ms-1 "
                                src={reg_entity4}
                                width={35}
                              />

                              <span className="row ms-2 px-3 text-secondary small ">
                                {t('kyc.entity_eligible_countries')}
                              </span>
                            </Col>
                            <Col md={4} className=" text-end py-3">
                              <Link to={""} className="text-primary small">
                                {t('common.learn_more')} &nbsp;&nbsp;
                                <i className="fa-solid fa-arrow-right"></i>
                              </Link>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          md={12}
                          className={`rounded-4 ${
                            theme === "light" && "bg-body-tertiary"
                          } mt-2`}
                        >
                          <Row className="p-2">
                            <Col md={8} className=" d-flex align-items-center">
                              <img
                                className="row ms-1 "
                                src={reg_entity4}
                                width={35}
                              />

                              <span className="row ms-2 px-3 text-secondary small">
                                {t('kyc.entity_eligible_types')}
                              </span>
                            </Col>
                            <Col md={4} className=" text-end py-3">
                              <Link to={""} className="text-primary small">
                                {t('common.learn_more')} &nbsp;&nbsp;
                                <i className="fa-solid fa-arrow-right"></i>
                              </Link>
                            </Col>
                          </Row>
                        </Col>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  initialValues: {
    RegisteredBusiness: state.entityAccount.entityAccountUserDetails.RegisteredBusiness || "",
  },
});

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  form: "entityWizard",
  enableReinitialize: true,
})(CreateEntityFirstQues);

export default connect(mapStateToProps)(form);
